export default class SaveSearch {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new SaveSearch;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-save-search', function(e) {
			e.preventDefault();
			window.location.href = $(this).attr('href') + window.location.search;
		});
	}
}
